import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../../../shared/providers/common.service';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { ValidationService } from '../../../shared/providers/validation.service';

@Component({
  selector: 'app-property-revison-list',
  templateUrl: './property-revison-list.component.html',
  styleUrls: ['./property-revison-list.component.css']
})
export class PropertyRevisonListComponent implements OnInit {

  constructor(private _commonService: CommonService, public authService: AuthenticationService, public _validationService: ValidationService,) { }

    @Input() historyFields: [];

  ngOnInit() {
  }
}
